<script lang="ts">
    // import src from '../../../assets/directions_car_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import TemplateRoundIcon from './TemplateRoundIcon.svelte';
    import { PointOnMap } from '../../components/Planning/VehiclesOnMap/PointOnMap';
    export let scale: number = 1;
    export let title: string = '';
    export let rounded: boolean = false;
    export let backgroundColor: string = '#f92672';

    let src = PointOnMap.getIconUrl(backgroundColor, 1, 40, 40, 'car', true);
    scale = scale * 1.2;
</script>

{#if rounded}
    <TemplateRoundIcon {src} {scale} alt={title} hover={title} on:click {backgroundColor} />
{:else}
    <TemplateIcon {src} {scale} alt={title} hover={title} on:click />
{/if}

<!--styleElement="width:20px; height:20px;"-->
<!--style="width:65px; height:65px;"-->
